<template>
	<div class="container_page">
		<div class="lang-radio-wrap">
			<a-radio-group v-model="filterData.lang" button-style="solid" @change="changeTabTop">
				<a-radio-button value="CH">中文版</a-radio-button>
				<a-radio-button value="EN">英文版</a-radio-button>
			</a-radio-group>
		</div>
		<a-form layout="inline" style="margin-bottom: 20px;">
			<a-form-item label="品牌名称">
				<a-input placeholder="请输入品牌名称" v-model="filterData.businessName"/>
			</a-form-item>

			<a-form-item label="发布状态">
				<a-select style="width: 200px" v-model="filterData.factoryStatus" class="mr12" placeholder="请选择发布状态"
						  show-search option-filter-prop="name" :filter-option="filterOption">
					<a-select-option v-for="(item, index) of commodityStatusList" :key="index" :value="item.value">
						{{ item.label }}
					</a-select-option>
				</a-select>
			</a-form-item>
			<a-form-item>
				<a-button class="mr12" type="primary" @click="toSearch(true)">查询</a-button>
				<a-button class="mr12" @click="toSearch(false)">重置</a-button>

				<a-button class="mr12" v-if="filterData.lang === 'CH' &amp;&amp; hasPermission('BRAND_IMPORT')" @click="triggerImport">导入</a-button>
				<a-button class="mr12" @click="handleExport">导出</a-button>
				<a-button class="mr12"  v-if="filterData.lang === 'CH' &amp;&amp; hasPermission('BRAND_ADD')" @click="addDetail" type="primary">新建</a-button>
			</a-form-item>
		</a-form>


		<!-- <div style="height: 20px;"></div> -->
		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
				 :loading="loading" rowKey="businessCode">
			<!-- 工厂编码 -->
			<template slot="businessCodeRender" slot-scope="text,record">
				<div>
					{{ record.businessCode }}
				</div>
			</template>
			<!-- 口碑评价 -->
			<template slot="avgRatingRender" slot-scope="text,record">
				<a-rate :default-value="record.avgRating" allow-half disabled class="compact-rate"
						style="font-size: 16px;"/>
				&nbsp;{{record.avgRating}}
			</template>
			<!-- 社会评价 显示数字，点击跳转 -->
			<template slot="socialCommentNumRender" slot-scope="text, record">
				<div style="color: #f00;">
					{{ record.socialCommentNum }}
				</div>
			</template>
			<!-- 用户评价 显示数字，点击跳转 -->
			<template slot="userCommentNumRender" slot-scope="text, record">
				<div style="color: #f00;">
					{{ record.userCommentNum }}
				</div>
			</template>
			<!-- 发布状态-->
			<template slot="factoryStatusRender" slot-scope="text, record">
				<div style="display: flex;align-items: center;">
					<a-switch :checked="!!record.factoryStatus"
							  @change="(checked) => handlePublishChange(checked, record)"/>
					<a-tag style="margin-left: 10px;" color="#2db7f5" v-if="record.factoryStatus == true">
						启用
					</a-tag>
					<a-tag style="margin-left: 10px;" v-else-if="record.factoryStatus == false">
						禁用
					</a-tag>
					<a-tag style="margin-left: 10px;" v-else></a-tag>
				</div>

			</template>
			<!-- 正经工厂222 -->
			<template slot="indexStatusRender" slot-scope="text, record">
				<div style="display: flex;align-items: center;">
					<a-switch :checked="!!Number(record.indexStatus)"
							  @change="(checked) => handleFactoryChange(checked, record)"/>
					<a-input style="margin-left: 10px;" v-if="record.indexStatus == true"
							 v-model.number="record.indexSort" placeholder="排序"
							 type="number" @blur="updateFactoryIndexSortApi(record)"
							 @keyup.enter="updateFactoryIndexSortApi(record)"/>
				</div>
			</template>

			<!-- 工厂排序111 -->
			<template slot="indexSortender" slot-scope="text, record">
				<a-input v-model.number="record.sort" placeholder="排序" type="number" @blur="handleSaveSort(record)"
						 @keyup.enter="handleSaveSort(record)"/>
			</template>

			<!-- 编辑，删除 -->
			<template slot="action" slot-scope="text, record">
				<div class="flex_center">
					<!-- 编辑 -->
					<span v-if="hasPermission('BRAND_EDIT')"><a-button type="link" @click="toDetail(record)">编辑</a-button></span>
                <a-popconfirm v-if="filterData.lang === 'CH' &amp;&amp; hasPermission('BRAND_DEL')" title="你确定删除这条信息吗？" okText="确定" cancelText="取消" @confirm="sureDelete(record)">
						<a-button type="link">删除</a-button>
					</a-popconfirm>
				</div>
			</template>
		</a-table>
		<a-modal :visible="imgModel.flag" width="880px" :closable="false" maskClosable :destroyOnClose="true">
			<template slot="footer">
				<a-button @click="imgModel.flag = false">关闭</a-button>
			</template>
			<span>
				<img :src="imgModel.url" alt="" style="width: 800px;height: 296px"/>
			</span>
		</a-modal>
		<a-modal :title="tipsModel.title" :visible="tipsModel.flag" @ok="tipsModel.onOk"
				 @cancel="tipsModel.flag = false">
			<span>
				{{ tipsModel.content }}
			</span>
		</a-modal>
		<a-modal :title="editModel.title" :visible="editModel.flag" width="800px" @ok="editModel.onOk"
				 @cancel="editModel.flag = false">
			<a-form-model :model="editModel" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row>
					<a-col :span="20">
						<a-form-model-item label="卡片图标">
							<!-- (长宽比例为1080：400) -->
							<div v-if="editModel.iconUrl">
								<viewer :images="[editModel.iconUrl]">
									<div class="er_content">
										<img class="er_content_img" :src="img"
											 v-for="(img,index) in [editModel.iconUrl]" :key="index">
									</div>
								</viewer>
								<!-- <img :src="editModel.iconUrl" alt="" style="width: 40px;height: 40px" /> -->
							</div>

							<div class="again_upload_box ml12">
								<input type="file" accept="image/" @change="handleUpdataFile"/>
								<i class="el-icon-box again_upload_icon"></i>
								<div class="bold" style="width: 100px">上传文件</div>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="20">
						<a-form-model-item label="卡片名称">
							<a-input v-model="editModel.name"/>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="20">
						<a-form-model-item label="开关状态" prop="giftCardStatus">
							<a-select v-model="editModel.giftCardStatus" class="mr12" placeholder="开关状态" show-search
									  option-filter-prop="name" :filter-option="filterOption">
								<a-select-option v-for="(item, index) of commodityStatusList" :key="index"
												 :value="item.value">
									{{ item.label }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="20">
						<a-form-model-item label="序号">
							<a-input v-model="editModel.sort"/>
						</a-form-model-item>
					</a-col>
				</a-row>


			</a-form-model>


		</a-modal>

		<a-modal title="导入品牌" :visible="importModel.flag" width="500px" :footer="null" @cancel="importModel.flag = false">
			<div style="display: flex; flex-direction: column; align-items: center; gap: 16px;">
				<a-button type="link" @click="handleDownloadTemplate">下载导入模板</a-button>
				<div class="import-upload-area" @click="triggerFileSelect" style="width: 100%; min-height: 160px; border: 2px dashed #d9d9d9; border-radius: 8px; display: flex; flex-direction: column; align-items: center; justify-content: center; cursor: pointer; background: #fafafa;">
					<div style="font-size: 48px; color: #40a9ff; line-height: 1;">+</div>
					<div style="margin-top: 8px; color: #666;">点击选择 Excel 文件</div>
					<div style="margin-top: 4px; font-size: 12px; color: #999;">支持 .xlsx 格式</div>
				</div>
				<input ref="importFileInput" type="file" accept=".xlsx" style="display: none" @change="handleImport" />
				<div v-if="importModel.selectedFile" style="color: #333;">
					已选择：{{ importModel.selectedFile.name }}
				</div>
				<a-button v-if="importModel.selectedFile" type="primary" :loading="importModel.uploading" @click="handleUpload">
					开始导入
				</a-button>
			</div>
		</a-modal>

		<a-modal title="导入结果" :visible="importModel.resultVisible" width="500px" :footer="null" @cancel="importModel.resultVisible = false">
			<div style="padding: 16px 0;" v-if="importModel.resultData">
				<div v-if="importModel.resultData.fileUrl" style="margin-bottom: 16px; padding: 12px; background: #fff2f0; border: 1px solid #ffccc7; border-radius: 4px;">
					<div style="color: #ff4d4f; margin-bottom: 8px;">部分数据导入失败，请下载错误文件查看详情：</div>
					<a-button type="primary" size="small" @click="downloadErrorFile(importModel.resultData.fileUrl)">
						下载错误文件
					</a-button>
				</div>
				<div style="text-align: center;">
					<a-button @click="importModel.resultVisible = false">关闭</a-button>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import cityData from '../../assets/json/citys_with_en.json'
	import {
		managerFactoryApi,
		factoriesExportApi,
		factoriesImportApi,
		factoriesImportTemplateApi,
		deleteFactoryApi,
		updateFactoryStatusApi,
		updateFactoryIndexStatusApi,
		updateFactorySortApi,
		updateFactoryIndexSortApi
	} from "../../api/index";

	export default {
		name: "cardsList",
		data() {
			return {
				cityList: cityData,
				checked: false,
				options: [{
					value: 'hn',
					label: '河南省',
					children: [{
						value: 'zz',
						label: '郑州市',
					},],
				},
					{
						value: 'hn',
						label: '北京',
						children: [{
							value: 'zz',
							label: '西城',
						},],
					}
				],
				releaseStatusList: [{
					label: "启用",
					value: true,
				},
					{
						label: "禁用",
						value: false,
					}
				],
				commodityStatusList: [{
					label: "开启",
					value: true,
				},
					{
						label: "关闭",
						value: false,
					},
				],
				columns: [{
					title: '序号',
					dataIndex: 'sort',
					key: 'sort',
					customRender: (text, record, index) => {
						return (this.pageInfo.current - 1) * this.pageInfo.pageSize + index + 1
					},
					width: 60,
				},
					{
						title: '品牌编码',
						dataIndex: 'businessCode',
						key: 'businessCode',
						scopedSlots: {
							customRender: 'businessCodeRender'
						},
					},
					{
						title: '品牌名称',
						dataIndex: 'businessName',
						key: 'businessName',
					},
					{
						title: '口碑评价',
						dataIndex: 'avgRating',
						key: 'avgRating',
						scopedSlots: {
							customRender: 'avgRatingRender'
						},
						width: 150,
						// className: 'red-header',
					},

					{
						title: '成立时间',
						dataIndex: 'establishDate',
						key: 'establishDate',
					},
					{
						title: '社会评价',
						dataIndex: 'socialCommentNum',
						key: 'socialCommentNum',
						scopedSlots: {
							customRender: 'socialCommentNumRender'
						},
					},
					{
						title: '用户评价',
						dataIndex: 'userCommentNum',
						key: 'userCommentNum',
						scopedSlots: {
							customRender: 'userCommentNumRender'
						},
					},
					{
						title: '发布状态',
						dataIndex: 'factoryStatus',
						key: 'factoryStatus',
						scopedSlots: {
							customRender: 'factoryStatusRender'
						},
					},
					{
						title: '首页推荐品牌',
						dataIndex: 'indexStatus',
						key: 'indexStatus',
						scopedSlots: {
							customRender: 'indexStatusRender'
						},
					},
					{
						title: '创建时间',
						dataIndex: 'createTime',
						key: 'createTime',
					},
					// "indexSort": 1, //正经工厂/首页推荐品牌 排序 工厂/品牌
					// // "sort": 10, //排序 工厂/品牌
					{
						title: '排序',
						dataIndex: 'indexSort',
						key: 'indexSort',
						scopedSlots: {
							customRender: 'indexSortender'
						},
					},
					{
						title: '操作',
						key: 'action',
						scopedSlots: {
							customRender: 'action'
						},
					}
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				imgModel: {
					flag: false,
					url: "",
				},
				tipsModel: {
					flag: false,
					title: "",
					content: "",
					giftCardId: 0,
					giftCardStatus: undefined,
					onOk: () => {
					},
				},
				editModel: {
					flag: false,
					title: "",
					name: '',
					iconUrl: "",
					sort: "",
					giftCardStatus: undefined,
					onOk: () => {
					},
				},
				formState: {
					"iconUrl": "", //卡片图标
					"name": "", //卡片名称
					"sort": 1 //序号
				},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
				filterData: {
					businessName: "",
					province: "",
					provinceCode: "",
					cityCode: "",
					city: "",
					factoryStatus: undefined,
					lang: "CH",
					businessType: "BRABD",
					indexStatus: null
				},
				importModel: {
					flag: false,
					selectedFile: null,
					uploading: false,
					resultVisible: false,
					resultData: null
				}
			};
		},
		created() {
			// 深拷贝 cityData 并去掉区一级，只保留省市
			// this.cityList = JSON.parse(JSON.stringify(cityData));
			// this.cityList.forEach(province => {
			// 	if (province.children) {
			// 		province.children.forEach(city => {
			// 			delete city.children;
			// 		});
			// 	}
			// });
		},
		activated() {
		},
		mounted() {
			const storedQuery = localStorage.getItem('brandManage_searchQuery');
			const storedPage = localStorage.getItem('brandManage_pageNo');
			if (storedQuery) {
				this.filterData = JSON.parse(storedQuery);
			} else {
			}
			sessionStorage.setItem("businessType","BRABD")
			this.getData(storedPage ? parseInt(storedPage) : 1);
		},
		beforeRouteLeave(to, from, next) {
			localStorage.setItem('brandManage_searchQuery', JSON.stringify(this.filterData));
			localStorage.setItem('brandManage_pageNo', this.pageInfo.current);
			next();
		},
		computed: {
			cascaderValue() {
				const { provinceCode, cityCode } = this.filterData;
				return provinceCode && cityCode ? [provinceCode, cityCode] : [];
			}
		},
		methods: {
			hasPermission(permission) {
				const resources = this.$store.state.userInfo.resources;
				return resources && resources.split(";").includes(permission);
			},
			// 正经工厂排序
			// 工厂/品牌列表 正经工厂排序     updateFactoryIndexSortApi
			updateFactoryIndexSortApi(record) {
				// return
				// 排序号为空不提交
				if (record.indexSort === undefined || record.indexSort === null || record.indexSort === '') {
					return
				}
				// 调用你已有的排序接口
				updateFactoryIndexSortApi({
					businessLangId: record.businessLangId,
					sort: record.indexSort
				}).then(res => {
					if (res.resultStatus) {
						this.$message.success('排序保存成功')
						this.getData(this.pageInfo.current) // 刷新列表，实现重排
					} else {
						this.$message.error('保存失败')
					}
				}).catch(err => {
					this.$message.error('保存失败')
				})
			},

			// 保存排序（输入框回车/失焦触发）
			handleSaveSort(record) {
				// 排序号为空不提交
				if (record.sort === undefined || record.sort === null || record.sort === '') {
					return
				}
				// 调用你已有的排序接口
				updateFactorySortApi({
					businessLangId: record.businessLangId,
					sort: record.sort
				}).then(res => {
					if (res.resultStatus) {
						this.$message.success('排序保存成功')
						this.getData(this.pageInfo.current) // 刷新列表，实现重排
					} else {
						this.$message.error('保存失败')
					}
				}).catch(err => {
					this.$message.error('保存失败')
				})
			},
			onChange(value, selectedOptions) {
				if (!selectedOptions || selectedOptions.length === 0) {
					this.filterData.province = '';
					this.filterData.provinceCode = '';
					this.filterData.city = '';
					this.filterData.cityCode = '';
					return;
				}
				this.filterData.province = selectedOptions[0].text
				this.filterData.provinceCode = selectedOptions[0].value
				this.filterData.city = selectedOptions[1].text
				this.filterData.cityCode = selectedOptions[1].value
			},
			CheckonChange(e) {
				this.filterData.indexStatus = e.target.checked
			},
			changeTabTop() {
				this.pageInfo.current = 1;
				this.getData(1);
			},
			// 删除
			handleDelete() {

			},
			handleExport() {
				this.getData(this.pageInfo.current, true);
			},
			triggerImport() {
				this.importModel.flag = true;
				this.importModel.selectedFile = null;
				this.importModel.resultData = null;
			},
			triggerFileSelect() {
				this.$refs.importFileInput.value = null;
				this.$refs.importFileInput.click();
			},
			handleImport(e) {
				this.importModel.selectedFile = e.target.files[0] || null;
			},
			handleUpload() {
				const file = this.importModel.selectedFile;
				if (!file) return;
				const formData = new FormData();
				formData.append('file', file);
				this.importModel.uploading = true;
				factoriesImportApi(formData,"BRABD").then((res) => {
					if (res.resultStatus) {
						const data = res.resultData || {};
						if (data.fileUrl) {
							// 有错误文件，显示结果弹框
							this.importModel.resultData = data;
							this.importModel.resultVisible = true;
						} else {
							this.$message.success(`导入成功，共 ${data.totalCount || 0} 条`);
							this.importModel.flag = false;
							this.getData(this.pageInfo.current);
						}
					} else {
						this.$message.error(res.errorMessage || '导入失败');
					}
				}).catch((err) => {
					console.error(err);
					this.$message.error('导入失败');
				}).finally(() => {
					this.importModel.uploading = false;
				});
			},
			handleDownloadTemplate() {
				const link = document.createElement('a');
				link.href = 'https://oss.chongmi.online/wxapp/importExcel/品牌模板.xlsx';
				link.download = '品牌导入模板.xlsx';
				link.click();
			},
			downloadErrorFile(url) {
				const link = document.createElement('a');
				link.href = url;
				link.download = decodeURIComponent(url.substring(url.lastIndexOf('/') + 1));
				link.click();
			},
			handleExport() {
				this.getData(this.pageInfo.current, true);
			},
			// 切换发布状态（带确认提示）
			handlePublishChange(checked, record) {
				// 动态生成提示文案
				let content = '';
				if (checked) {
					// 切换为 启用
					content = '切换为启用状态，则当前数据用户前端可查看，确认变更当前数据状态？';
				} else {
					// 切换为 禁用
					content = '切换为禁用状态，则当前数据前端不可查看，确认变更当前数据状态？';
				}
				this.$confirm({
					title: '操作确认',
					content: content,
					okText: '确定',
					cancelText: '取消',
					onOk: () => {
						// 确认后执行的操作
						record.factoryStatus = checked ? 1 : 0; // 接口需要数字，存回数字
						// 这里可以调用接口更新状态
						// TODO
						this.updateStatusApi(record.businessLangId)
					},
					onCancel: () => {
						// 取消时，保持开关原来的状态不变
						console.log('已取消操作');
					}
				});
			},
			updateStatusApi(businessLangId) {
				updateFactoryStatusApi({
					businessLangId: businessLangId,
				})
						.then((res) => {
							if (res.resultStatus) {
								this.$message.success(
										"修改成功"
								);
								this.editModel.flag = false;
							} else {
								console.log("res", res);
							}
						})
						.catch((error) => {
							console.log(error);
						})
						.finally(() => {
							this.getData(this.pageInfo.current)
						})
			},

			// 切换正经工厂状态（带确认提示）
			handleFactoryChange(checked, record) {
				const actionText = checked ? '开启' : '关闭';
				this.$confirm({
					title: '操作确认',
					content: checked ? `确认将当前品牌设置为首页推荐品牌` : `确认取消当前品牌厂为首页推荐品牌`,
					okText: '确定',
					cancelText: '取消',
					onOk: () => {
						record.indexStatus = checked ? '1' : '0'; // indexStatus存字符串'1'/'0'
						// 这里可以调用接口更新状态
						this.updateIndexStatusApi(record.businessLangId)
					},
					onCancel: () => {
						console.log('已取消操作');
					}
				});
			},
			// 正经工厂状态
			updateIndexStatusApi(businessLangId) {
				updateFactoryIndexStatusApi({
					businessLangId: businessLangId,
				})
						.then((res) => {
							if (res.resultStatus) {
								this.$message.success(
										"修改成功"
								);
								this.editModel.flag = false;
							} else {
								console.log("res", res);
							}
						})
						.catch((error) => {
							console.log(error);
						})
						.finally(() => {
							this.getData(this.pageInfo.current)
						})
			},

			//

			handleBlur() {
			},
			handleFocus() {
			},
			filterOption(input, option) {
				return (
						option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},
			toSearch(flag) {
				if (flag) {
					this.getData(1);
				} else {
					let lang = this.filterData.lang
					this.filterData = {
						businessName: "",
						province: "",
						provinceCode: "",
						cityCode: "",
						city: "",
						factoryStatus: undefined,
						lang:lang,
						businessType: "BRABD",
						indexStatus: null,
					};
					this.checked = false;
					this.getData(1);
				}
			},
			getData(page = 1, isExport = false) {
				this.pageInfo.current = page;
				if (this.loading && !isExport) {
					return;
				}
				this.loading = true;
				const params = {
					pageNo: isExport ? 1 : this.pageInfo.current,
					pageSize: isExport ? 99999 : this.pageInfo.pageSize,
					businessName: this.filterData.businessName,
					province: this.filterData.provinceCode,
					city: this.filterData.cityCode,
					factoryStatus: this.filterData.factoryStatus,
					lang: this.filterData.lang,
					businessType: this.filterData.businessType,
					commentStatus: false,
					indexStatus: this.filterData.indexStatus ? this.filterData.indexStatus : null
				};
				// 去掉空字符串参数
				Object.keys(params).forEach(key => { if (params[key] === '') delete params[key]; });
				console.log(params)
				if (isExport) {
					factoriesExportApi(params).then((res) => {
						const blob = new Blob([res]);
						const link = document.createElement('a');
						link.href = URL.createObjectURL(blob);
						link.download = `品牌列表_${this.filterData.lang === 'EN' ? 'en' : 'zh'}.xlsx`;
						link.click();
						URL.revokeObjectURL(link.href);
					}).catch((err) => {
						console.error(err);
					}).finally(() => {
						this.loading = false;
					});
					return;
				}

				managerFactoryApi(params)
						.then((res) => {
							if (res.resultStatus) {
								this.tableData = res.resultData.dataList || [];
								this.pageInfo.total = res.resultData.totalNum || 0;
							} else {
								this.tableData = [];
								this.pageInfo.total = 0;
							}
						})
						.catch((err) => {
							console.error(err);
						})
						.finally(() => {
							this.loading = false;
						});
			},
			toAdd() {
				this.editModel = {
					flag: true,
					title: "新增",
					giftCardId: 0,
					iconUrl: "",
					name: '',
					giftCardStatus: undefined,
					sort: this.pageInfo.total + 1,
					onOk: this.sureEdit,
				};
			},
			addDetail() {
                this.$store.commit('ADD_LABEL', 'BRANDEDIT')
                window.__brandEditPath = '/factory/factoryDetail/add/2/0'
                this.$router.push({
					name: 'FACTORYDETAIL',
					params: {
						id: 0,
						ifFacOrBr: '2',
						type: 'add', // 标记编辑
					}
				});
			},
            toDetail(record) {
                this.$store.commit('ADD_LABEL', 'BRANDEDIT')
                window.__brandEditPath = '/factory/factoryDetail/edit/2/' + record.businessLangId
				this.$router.push({
					name: 'FACTORYDETAIL',
					params: {
						id: record.businessLangId,
						ifFacOrBr: '2',
						type: 'edit' // 标记编辑
					}
				});
			},
			toEdit(data) {
				this.editModel = {
					flag: true,
					title: "编辑",
					giftCardId: data.giftCardId,
					iconUrl: data.iconUrl,
					sort: data.sort,
					name: data.name,
					giftCardStatus: data.giftCardStatus,
					onOk: this.sureEdit,
				};
			},
			confirm() {

			},
			sureEdit() {
				cardListCardsAddApi({
					name: this.editModel.name,
					iconUrl: this.editModel.iconUrl,
					sort: this.editModel.sort,
					giftCardId: this.editModel.giftCardId,
					giftCardStatus: this.editModel.giftCardStatus
				})
						.then((res) => {
							if (res.resultStatus) {
								this.$message.success(
										this.editModel.bannerId ? "编辑成功" : "新增成功"
								);
								this.editModel.flag = false;
							} else {
								console.log("res", res);
							}
						})
						.catch((error) => {
							console.log(error);
						})
						.finally(() => {
							this.getData(this.pageInfo.current)
						})
			},
			toDelete(data) {
				this.tipsModel = {
					flag: true,
					title: "删除卡片名称",
					content: "确认要删除卡片名称吗？",
					giftCardId: data.giftCardId,
					onOk: this.sureDelete,
				};
			},
			toSeeImg(data) {
				this.imgModel = {
					flag: true,
					url: data.iconUrl,
				};
			},
			// here123
			sureDelete(record) {
				if (this.loading) {
					return;
				}
				this.loading = true;
				deleteFactoryApi({
					businessLangId: record.businessLangId,
				})
						.then((res) => {
							if (res.resultStatus) {
								this.$message.success("删除成功");
								// this.tipsModel.flag = false;
							} else {
								console.log("res", res);
							}
						})
						.catch((error) => {
							console.log(error);
						})
						.finally(() => {
							this.loading = false;
							this.getData(this.pageInfo.current);
						});
			},
			// 上传文件
			handleUpdataFile(e) {
				if (e.target.files.length) {
					const file = e.target.files[0];
					console.log("file", file);
					if (file) {
						const form = new FormData();
						form.append("file", file);
						console.log("form", form);
						getOssAuth(form).then((res) => {
							if (res.resultStatus) {
								this.editModel.iconUrl = res.resultData.fileLink;
							}
						});
					}
				}
			},
		},
	};
</script>

<style lang="less">
	.container_page {
		padding: 20px;
		background: #ffffff;

		.lang-radio-wrap {
			display: flex;
			justify-content: center;
			margin-bottom: 16px;
		}

		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}

		.compact-rate .ant-rate-star:not(:last-child) {
			margin-right: 2px;
		}
	}
</style>
